package fr.manyverse.app.infrastructure.monitoring

import co.touchlab.kermit.LogWriter
import co.touchlab.kermit.Severity

/**
 * Writer Kermit qui alimente le [CrashReporter].
 *
 * - Chaque log (hors Verbose) devient un breadcrumb : ce sont les lignes qui précèdent une
 *   erreur et qu'on retrouve dans le détail de l'événement Sentry.
 * - Un log d'erreur accompagné d'une exception est envoyé comme erreur non fatale. C'est ce
 *   qui rend visibles les échecs rattrapés en `Result.failure()`, qui ne crashent jamais l'app.
 */
class CrashReportingLogWriter(private val crashReporter: CrashReporter) : LogWriter() {

    override fun isLoggable(tag: String, severity: Severity): Boolean = severity >= Severity.Debug

    override fun log(severity: Severity, message: String, tag: String, throwable: Throwable?) {
        crashReporter.addBreadcrumb(severity, tag, message)
        if (severity >= Severity.Error && throwable != null) {
            crashReporter.captureException(throwable, tag, message)
        }
    }
}
